export const getFileType = (file: File): string | undefined => {
	const fileType = file.name.match(/\.[0-9a-zA-Z]{1,}$/gm)?.[0];
	return fileType?.substring(1);
};
